module.exports = __webpack_public_path__ + "static/media/spinner.efa1a4fa.svg";